import React from 'react';
import OboDashboardV2 from '../containers/OboDashboardV2/OboDashboardV2';

const OboDashboardV2Page: React.FC = () => {
  return <OboDashboardV2 />;
};

export default OboDashboardV2Page;
